import React, { useEffect, useState } from "react";
import FlowImg from '../../../../Assets/Images/Flow.png';
import GroupQuardantsFlow from '../groupReport-pdf/GroupQuardantsFlow';
import HeaderPreview from '../../../GeneratePdf/HeaderPreview';
import FooterPreview from '../../../GeneratePdf/FooterPreview';

export default function YourQuardrantsFlowGroup({ groupData, previewData, reportType, pageNumber }) {
  
  const styles = {
    coverSection: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 0px',
      fontFamily: 'Helvetica, sans-serif',
    },
    coverTitle: {
      fontSize: '24px',
      fontWeight: 700,
      lineHeight: '41px',
      color: '#426B88', 
    },
    paragraph: {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px',
      color: '#245775',
    },
    secondSection: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
    },
    coverImage: {
      width: '280px',
      height: '330px',
      objectFit: 'contain',
      margin: '10px 0',
    },
    text: {
      fontWeight: 700,
      fontSize: '11px',
      lineHeight: '15px',
      color: '#00577D',
      textAlign: 'center',
    },
    longText: {
      fontWeight: 700,
      fontSize: '24px',
      lineHeight: '35px',
      color: '#426B88',
      textAlign: 'center',
      marginTop: '15px',
    },
  };

  // --- NEW LOGIC FOR FLOW TEXT ---
  const [flowText, setFlowText] = useState("");

  useEffect(() => {
    if (!previewData || !groupData?.teamname) {
      setFlowText("");
      return;
    }
    const teamData = previewData.find(team => team.teamname === groupData.teamname);
    if (!teamData || !Array.isArray(teamData.results)) {
      setFlowText("");
      return;
    }
    // Calculate averages for each quadrant
    const assessmentResults = [];
    teamData.results.forEach(assessment => {
      if (!assessment.variables || !Array.isArray(assessment.variables)) return;
      const variables = {};
      assessment.variables.forEach(variable => {
        variables[variable.variable] = Number(variable.score) || 0;
      });
      const heart_r1_m = variables["heart_round1_m"] || 0;
      const soul_r1_m = variables["soul_round1_m"] || 0;
      const mind_r1_m = variables["mind_round1_m"] || 0;
      const strength_r1_m = variables["str_round1_m"] || 0;
      const heart_r2_m = variables["heart_round2_m"] || 0;
      const soul_r2_m = variables["soul_round2_m"] || 0;
      const mind_r2_m = variables["mind_round2_m"] || 0;
      const strength_r2_m = variables["str_round2_m"] || 0;
      const heart_r1_l = variables["heart_round1_l"] || 0;
      const soul_r1_l = variables["soul_round1_l"] || 0;
      const mind_r1_l = variables["mind_round1_l"] || 0;
      const strength_r1_l = variables["str_round1_l"] || 0;
      const heart_r2_l = variables["heart_round2_l"] || 0;
      const soul_r2_l = variables["soul_round2_l"] || 0;
      const mind_r2_l = variables["mind_round2_l"] || 0;
      const strength_r2_l = variables["str_round2_l"] || 0;
      let most_score = Math.max(heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m);
      let second_most_score = Math.max(heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m) / 2;
      let least_score = Math.max(heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l);
      let second_least_score = Math.max(heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l) / 2;
      if (least_score >= second_least_score) {
        least_score = second_least_score - 1;
      }
      const total = most_score + second_most_score + least_score + second_least_score;
      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score / total) * 100;
      const labels_arr = ["heart", "soul", "mind", "strength"];
      const mostValues = [heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m];
      const secondMostValues = [heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m];
      const leastValues = [heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l];
      const secondLeastValues = [heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l];
      const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];
      const most_label = getLabel(mostValues, Math.max(...mostValues));
      const second_most_label = getLabel(secondMostValues, Math.max(...secondMostValues));
      const least_label = getLabel(leastValues, Math.max(...leastValues));
      const second_least_label = getLabel(secondLeastValues, Math.max(...secondLeastValues));
      const quadrantPercentages = {
        strength: 0,
        heart: 0,
        soul: 0,
        mind: 0
      };
      quadrantPercentages[most_label] = most_per;
      quadrantPercentages[second_most_label] = second_most_per;
      quadrantPercentages[least_label] = least_per;
      quadrantPercentages[second_least_label] = second_least_per;
      assessmentResults.push(quadrantPercentages);
    });
    // Average for each quadrant
    const avg = { mind: 0, strength: 0, soul: 0, heart: 0 };
    assessmentResults.forEach(res => {
      Object.keys(avg).forEach(key => {
        avg[key] += res[key] || 0;
      });
    });
    Object.keys(avg).forEach(key => {
      avg[key] = assessmentResults.length ? Math.round(avg[key] / assessmentResults.length) : 0;
    });
    // Sort for flow
    const sorted = Object.entries(avg).sort((a, b) => b[1] - a[1]);
    // Use highest and second-highest for the flow text
    if (sorted.length >= 2) {
      setFlowText(`YOU FLOW FROM ${sorted[0][0].toUpperCase()} TO ${sorted[1][0].toUpperCase()}`);
    } else {
      setFlowText("");
    }
  }, [previewData, groupData]);

  return (
   <div>
    <HeaderPreview/>
     <div style={styles.coverSection}>
      <div style={styles.contentContainer}>
        <div style={styles.secondSection}>
          <div style={styles.text}>GROUP</div>
          <GroupQuardantsFlow groupData={groupData} previewData={previewData}/>
        </div>
      </div>
    </div>
    <FooterPreview pageNumber={pageNumber} reportType={reportType} />
   </div>
  );
}
